import React from 'react';
import PropTypes from 'prop-types';

import { Card as KitCard } from '@beef/ui-kit';
import classNames from 'classnames/bind';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const Card = ({
  size, color, className, withHover, children,
}) => (
  <KitCard
    withHover={withHover}
    className={cx({
      [className]: !!className,
      [`card--${size}`]: !!size,
      [`card--${color}`]: !!color,
    })}
  >
    {children}
  </KitCard>
);

Card.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
  withHover: PropTypes.bool,
};

export default Card;
